import { FilterModal } from 'components/common/ComposableFilters';
import { Tooltip } from 'components/ui';
import { PAID_PLAN_TOOLTIP, subscriptionAccess } from 'config';
import querystring from 'querystring';
import { useState } from 'react';
import { useAppSelector } from 'store';
import { composableFiltersState } from 'store/composableFiltersSlice';
import { useGetFiltersQuery } from 'store/services/segmentsApi';
import { useParseURLQueryParams } from 'utils';
import { useStoreSubscriptionPlan } from 'utils/useStoreSubscriptionPlan';

export const ComposableFilters = () => {
  const [modalOpen, setModalOpen] = useState(false);

  const { rawQueryParams } = useParseURLQueryParams();

  const queryParams = querystring.stringify({
    store_name: rawQueryParams?.store_name,
  });

  useGetFiltersQuery(
    { serializedParams: queryParams },
    { skip: !!!rawQueryParams.store_name }
  );

  const { storeSubscriptionPlan } = useStoreSubscriptionPlan();

  const { applied } = useAppSelector(composableFiltersState);

  const filtersAppliedLength = applied.filters.conditions.length;
  const managedSegmentfilters = applied.filters.conditions.some((filter) =>
    filter.type === 'singleFilterClause'
      ? filter.property.name.startsWith('managed_segment')
      : false
  );

  return (
    <div className="flex items-center h-full py-0.5 space-x-3">
      <div className="flex flex-col justify-center h-full pr-4 text-black text-opacity-50 border-r-2">
        <div>
          <p className="px-3 font-bold truncate text-segments-accent-color-1 rounded-segments-32px text-segments-13px">
            {filtersAppliedLength} filter(s) applied
          </p>
        </div>
      </div>
      <Tooltip
        text={PAID_PLAN_TOOLTIP}
        disabled={!!!(storeSubscriptionPlan < subscriptionAccess.filters)}
      >
        <button
          className="flex items-center px-4 py-1.5 space-x-2 bg-segments-accent-color-1 rounded-xl ml-4 disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={() => setModalOpen(!modalOpen)}
          disabled={
            storeSubscriptionPlan < subscriptionAccess.filters ||
            managedSegmentfilters
          }
        >
          <EditIcon />
          <p className="hidden font-bold text-white truncate disabled:cursor-not-allowed disabled:opacity-50 lg:block">
            Edit filters
          </p>
        </button>
      </Tooltip>
      <FilterModal modalOpen={modalOpen} setModalOpen={setModalOpen} />
    </div>
  );
};

function EditIcon() {
  return (
    <svg
      className="w-5 h-5 text-white"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
    >
      <path
        d="M14.375 5H17.5M2.5 5h9.375M14.375 15H17.5M2.5 15h9.375M8.125 10H17.5M2.5 10h3.125M13.125 6.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM6.875 11.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM13.125 16.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
